export const getMasterFieldName = (fieldName: string) => {
  return fieldName.includes('.') ? fieldName.split('.')[0] : fieldName;
};
